"use client";

import { useEffect } from "react";
import { pushEvent } from "@/lib/analytics/gtm";
import { trackDemand } from "@/lib/analytics/demand";

/**
 * Delegated click listener for every tel: link on the site. Covers React
 * components AND guide content injected via dangerouslySetInnerHTML, so new
 * tel: links are tracked without per-callsite wiring. Capture phase so the
 * event is pushed before mobile navigates to the dialer.
 *
 * Also logged first-party as a DemandEvent (lib/analytics/demand.ts), which
 * counts the clicks GTM never sees for lack of consent. Importing that module
 * here, in the root layout, is what captures the landing page's utm_*.
 */
export default function PhoneClickTracker() {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = e.target as Element | null;
      const anchor = target?.closest?.('a[href^="tel:"]');
      if (!anchor) return;
      const href = anchor.getAttribute("href") ?? "";
      const locale = window.location.pathname.startsWith("/en") ? "en" : "sv";
      pushEvent(
        {
          event: "phone_call_click",
          phone_number: href.slice(4),
          page_path: window.location.pathname,
        },
        locale,
      );
      trackDemand({ type: "phone_click", number: href.slice(4, 44) });
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return null;
}
